<div class="formulario">
  <div class="container">
    <form class="myForm" [formGroup]="formUser" >
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Nombre</label>
              <input class="form-control" type="text" formControlName="nombre">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Apellidos</label>
              <input class="form-control" type="text" formControlName="apellidos">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">ROLE</label>
              <input class="form-control" type="text" formControlName="role">
            </div>
          </div>
          <div class="col-lg-6">
           
            <div class="input-group mb-3" style="margin-top: 34px;
            margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                    <div class="input-group-text">
                        <label>ACTIVO</label>
                        <p-inputSwitch formControlName="status"></p-inputSwitch>
                    </div>
                </div>
            </div>
        </div>
          <div class="col-lg-6">
            <div class="form-group">
              <span>Almacenamiento utilizado {{almacenamiento}} de un 1GB </span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>